import React, { Suspense, lazy } from 'react';
import { useTranslation } from 'react-i18next';
import { Loader } from 'components/_new/Loader';

const VideoCallFeature = lazy(() => import('./VideocallCockpitFeature'));

export const VideoCallPage = () => {
	const { t } = useTranslation();

	return (
		<Suspense fallback={<Loader text={t('videocall.page.loadingRoom')} />}>
			<VideoCallFeature />
		</Suspense>
	);
};
